import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-dz",
  "use": "icon-icon-dz-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" id=\"icon-icon-dz\">\n  <path fill=\"#fff\" d=\"M256 0h256v512H256z\" />\n  <path fill=\"#006233\" d=\"M0 0h256v512H0z\" />\n  <path fill=\"#d21034\" d=\"M367 192a128 128 0 1 0 0 128 102.4 102.4 0 1 1 0-128m4.2 64L256 218.4l71.7 98.2V195.4L256 293.6z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol